import useConversations from './hooks/useConversationList';
import ConversationListItem from './components/ConversationListItem';
import ConversationListSkeleton from './components/ConversationListSkeleton';
import DeleteConversationModal from './components/DeleteConversationModal/DeleteConversationModal';
import { useLanguageData } from '@/common/hooks/useLanguageData';
import {
	ListWrapper,
	ListHeader,
	List,
	LoadingText,
} from './conversationList.styles';

const ConversationsList = () => {
	const t = useLanguageData('chat');
	const nav = useLanguageData('nav');
	const {
		conversations,
		isLoading,
		activeConversationId,
		handleConversationClick,
		handleDeleteRequest,
		deleteModal,
		handleCloseDeleteModal,
		handleConfirmDelete,
		isDeleteInProgress,
		formatTime,
	} = useConversations();

	return (
		<ListWrapper>
			<ListHeader>
				<h2>{nav.chat}</h2>
			</ListHeader>
			{isLoading ? (
				<ConversationListSkeleton />
			) : (
				<List>
					{conversations.length === 0 ? (
						<LoadingText>{t.noConversationsYet}</LoadingText>
					) : (
						conversations.map((conv) => (
							<ConversationListItem
								key={conv.id}
								conversation={conv}
								isActive={conv.id === activeConversationId}
								onClick={() => handleConversationClick(conv.id)}
								onDelete={handleDeleteRequest}
								isDeleting={isDeleteInProgress}
								formatTime={formatTime}
							/>
						))
					)}
				</List>
			)}
			<DeleteConversationModal
				open={deleteModal.open}
				phase={deleteModal.phase}
				onClose={handleCloseDeleteModal}
				onConfirm={handleConfirmDelete}
			/>
		</ListWrapper>
	);
};

export default ConversationsList;
